module.exports = __webpack_public_path__ + "static/important-6aee5b040ec562907b764eb1680df371.png";